import { render, staticRenderFns } from "./dataKanban.vue?vue&type=template&id=58cb55ac&scoped=true&"
import script from "./dataKanban.vue?vue&type=script&lang=js&"
export * from "./dataKanban.vue?vue&type=script&lang=js&"
import style0 from "./dataKanban.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dataKanban.vue?vue&type=style&index=1&id=58cb55ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb55ac",
  null
  
)

export default component.exports